import { FormattedMessage } from 'react-intl';
import * as React from 'react';


export const messages = {

  PAYMENT_COMPLETED_NOTICE: (
      <FormattedMessage
          id="payment-completed-notice"
          defaultMessage="Your Payment Information was updated"
      />),
  PAYMENT_NOT_COMPLETED_NOTICE: (
      <FormattedMessage
          id="payment-not-completed-notice"
          defaultMessage="Subscription is not active."
      />),
  VIEW_SIGNING_SESSIONS: <FormattedMessage id="view-signing-sessions" defaultMessage="View Signing Sessions" />,
  PAYMENT_COMPLETED: <FormattedMessage id="payment-completed" defaultMessage="Payment information was Updated!" />,
  PAYMENT_NOT_COMPLETED: <FormattedMessage id="payment-not-completed" defaultMessage="Payment was not completed!" />,
  PAYMENT_PROCESSING: <FormattedMessage id="payment-processing" defaultMessage="Waiting for payment information confirmation" />,
  CONFIRMATION: <FormattedMessage id="confirmation" defaultMessage="Confirmation" />,
};
